import { DEFAULT_DELIVERY_PRICING_CONFIG } from '../utils/deliveryPricing';

const publicExperienceFallback = {
  contract: 'public-experience',
  schemaVersion: 'v1',
  instance: {
    key: 'glace',
    name: 'Glace Confeitaria',
    locale: 'pt-BR',
    timezone: 'America/Sao_Paulo',
    status: 'active',
  },
  data: {
    branding: {
      displayName: 'Glace Confeitaria',
      legalName: 'Glace Confeitaria',
      tagline: 'Brownies artesanais e encomendas sob medida',
      logo: {
        src: '/images/logo.png',
        alt: 'Logo Glace Confeitaria',
      },
      favicon: {
        src: '/images/icone.png',
      },
      contact: {
        whatsapp: '5532984860949',
        instagram: 'https://www.instagram.com/glaceconfeitariaa',
      },
    },
    theme: {
      tokens: {
        colorPrimary: '#751215',
        colorSecondary: '#D4AF37',
        colorSurface: '#FFF8F5',
        colorText: '#2F2321',
        radiusMd: '16px',
        radiusLg: '24px',
      },
    },
    navigation: {
      header: [
        {
          id: 'home',
          label: 'In\u00edcio',
          href: '/',
          kind: 'internal',
          visible: true,
          sortOrder: 0,
        },
        {
          id: 'menu',
          label: 'Card\u00e1pio',
          href: '/cardapio',
          kind: 'internal',
          visible: true,
          sortOrder: 1,
        },
      ],
      footer: [
        {
          id: 'instagram',
          label: 'Instagram',
          href: 'https://www.instagram.com/glaceconfeitariaa',
          kind: 'external',
          visible: true,
          sortOrder: 0,
        },
        {
          id: 'whatsapp',
          label: 'WhatsApp',
          href: 'https://api.whatsapp.com/send?phone=5532984860949',
          kind: 'external',
          visible: true,
          sortOrder: 1,
        },
      ],
      primaryCta: {
        id: 'cart',
        label: 'Carrinho',
        href: '/carrinho',
        kind: 'internal',
        emphasis: 'primary',
      },
    },
    pages: {
      home: {
        seo: {
          title: 'Glace Confeitaria',
          description: 'Brownies artesanais, presentes e encomendas sob medida.',
        },
        hero: {
          eyebrow: 'Glace online',
          headline: 'Brownies artesanais para o dia a dia e para encomendas especiais',
          supportingText:
            'Escolha, personalize e continue seu atendimento pelo WhatsApp com o pedido j\u00e1 registrado.',
          media: {
            desktopImage: '/images/capa-desktop.png',
            mobileImage: '/images/capa.png',
          },
          cta: {
            id: 'hero-cta',
            label: 'Ver Card\u00e1pio',
            href: '/cardapio',
            kind: 'internal',
            emphasis: 'primary',
          },
        },
        story: {
          eyebrow: 'Nossa hist\u00f3ria',
          title: 'Uma receita feita para virar mem\u00f3ria',
          text:
            'A Glac\u00ea nasceu do desejo de transformar o brownie do dia a dia em um gesto de afeto. Entre fornadas, testes e embalagens pensadas com carinho, fomos criando uma confeitaria que mistura sabor intenso, textura macia e um olhar delicado para presentear.\n\nHoje cada caixa sai da nossa cozinha com o mesmo cuidado do come\u00e7o: ingredientes selecionados, acabamento artesanal e a vontade de fazer cada pedido chegar com cara de momento especial.',
          framePrefix: '/videos/brownie-frames/frame-',
          frameCount: 240,
          frameExtension: 'webp',
          videoSrc: '/videos/brownie.mp4',
          mobileVideoSrc: '/videos/brownie.mp4',
        },
        sections: [],
      },
      entries: [],
    },
    ordering: {
      enabled: true,
      channel: 'whatsapp',
      whatsappNumber: '5532984860949',
      allowedDeliveryMethods: ['Retirada', 'Entrega'],
      requiresBackendValidation: true,
      scheduleWindowDays: 10,
      timeSlots: [
        {
          id: 'manha',
          label: '09:00 - 12:00',
          startTime: '09:00',
          endTime: '12:00',
          deliveryMethods: ['Retirada', 'Entrega'],
        },
        {
          id: 'tarde',
          label: '14:00 - 18:00',
          startTime: '14:00',
          endTime: '18:00',
          deliveryMethods: ['Retirada', 'Entrega'],
        },
        {
          id: 'noite',
          label: '19:00 - 21:00',
          startTime: '19:00',
          endTime: '21:00',
          deliveryMethods: ['Retirada', 'Entrega'],
        },
      ],
      deliveryPricing: DEFAULT_DELIVERY_PRICING_CONFIG,
    },
    featureFlags: {
      dynamicHomeEnabled: true,
      dynamicNavigationEnabled: true,
      dynamicFooterEnabled: true,
      publicOrderingEnabled: true,
    },
    fallback: {
      mode: 'last_known_good',
      allowStaticMenuFallback: true,
    },
  },
};

export default publicExperienceFallback;
